import { AlertMessage, removeAlertByID, selectAlerts } from '@state/alertSlice';
import { store } from '@state/configureStore';
import { selectIsTournamentRoute } from '@state/pageSlice';
import { ReactNode, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { Provider, useDispatch, useSelector } from 'react-redux';
import './Alert.scss';

export const AlertProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const alerts = useSelector(selectAlerts);
    const isTournamentRoute = useSelector(selectIsTournamentRoute);
    const dispatch = useDispatch();

    return (
        <Provider store={store}>
            {children}
            <div className={`custom-alert ${isTournamentRoute ? 'tournament-alert' : ''}`}>
                {alerts.map((alert) => (
                    <AlertComponent key={alert.id} alert={alert} onClose={() => dispatch(removeAlertByID(alert.id))} />
                ))}
            </div>
        </Provider>
    );
};

const AlertComponent = ({ alert, onClose }: { alert: AlertMessage; onClose: () => void }) => {
    useEffect(() => {
        if (alert.type === 'success' || alert.type === 'error') {
            const timer = setTimeout(() => {
                onClose();
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [alert, onClose]);

    const getVariant = (type: AlertMessage['type']) => {
        switch (type) {
            case 'success':
                return 'success';
            case 'error':
                return 'danger';
            case 'info':
                return 'info';
            case 'warning':
                return 'warning';
            default:
                return 'light';
        }
    };

    return (
        <Alert key={alert.id} variant={getVariant(alert.type)} dismissible={true} onClose={onClose}>
            {alert.message}
        </Alert>
    );
};
